import React, { useContext, useMemo, useState, useRef, useEffect } from "react";
import HeroMain from "../../components/innerPageHero/HeroMain";
import Pagereview from "../../components/pageReview/Pagereview";
import cardImg from "../../assets/images/card-image.jpg";
import SegmentedTab from "../../components/segmentedTab/SegmentedTab";
import { FormContext } from "../CMSRenderer/CMSRenderer";
import moment from "moment";

const PublicationCard = ({ title, file, image, view, currentLang }) => (
  <a href={file} target="_blank" rel="noopener noreferrer">
    <dda-image-card
      image_src={view === "grid" ? image || cardImg : ""}
      custom_class="cursor-pointer"
      component_mode=""
      class="hydrated"
    >
      <div className="-mt-4">
        <div className="flex justify-between mt-4 mb-2">
          <p className="body Bold text-primary">{title}</p>
          {currentLang === "en" ? (
            <i className="material-symbols-outlined text-primary">
              arrow_circle_right
            </i>
          ) : (
            <i className="material-symbols-outlined text-primary">
              arrow_circle_left
            </i>
          )}
        </div>
      </div>
    </dda-image-card>
  </a>
);

const PublicationsAndMedicalLibrary = ({ config }) => {
  const [view, setView] = useState("grid");
  const { currentLang } = useContext(FormContext);
  const [search, setSearch] = useState("");
  const [activeCategory, setActiveCategory] = useState("reports");
  const searchInputRef = useRef(null);

  const publicationsData = useMemo(
    () => ({
      categories: [
        { id: "reports", nameEN: "Reports", nameAR: "التقارير" },
        { id: "books", nameEN: "Books", nameAR: "الكتب" },
        // { id: "journals", nameEN: "Journals", nameAR: "المجلات" },
        // { id: "medical-library", nameEN: "Medical Library", nameAR: "المكتبة الطبية" },
        {
          id: "articles",
          nameEN: "Articles and Studies",
          nameAR: "المقالات والدراسات",
        },
      ],
      items: [
        {
          id: 1,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2024 ",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2024 ",
          file: "/attachments/medialib/ef77403a-c9d6-4624-b8e9-0b4c067d1bdf-1781256303209-286883404-HASD_2024.pdf",
          image:
            "/attachments/medialib/f486bf39-f4ea-497c-a366-5b97bbc3ad34-1781256315839-696543664-Reports_HASD_2024.jpg",
        },
        {
          id: 2,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2023",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2023",
          file: "/attachments/medialib/b68d7878-d206-41a0-aa8b-ea66dbe8b04b-1759338504142-84651694-Health Accounts System of Dubai 2023.pdf",
          image:
            "/attachments/medialib/c2ac032a-1faf-4a3e-a0cf-fb3c1844e482-1759740864932-81959213-Reports_HASD_2023.jpg",
        },
        {
          id: 3,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2022",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2022",
          file: "/attachments/medialib/852158cb-61e5-422d-9224-eee7da1fb6f2-1759338481386-988328595-Health Accounts System of Dubai 2022.pdf",
          image:
            "/attachments/medialib/93fbab39-14ad-4c71-8025-cc31ac87e25a-1759740856573-180432184-Reports_HASD_2022.jpg",
        },
        {
          id: 4,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2021",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2021",
          file: "/attachments/medialib/c3444051-3366-4d19-8d88-0cb44f63621f-1759338447054-902516725-Health Accounts System of Dubai 2021.pdf",
          image:
            "/attachments/medialib/ec08e2e1-18ef-4d53-b34f-f1edecb7b39d-1759740773678-727900028-Reports_HASD_2021.jpg",
        },
        {
          id: 5,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2020",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2020",
          file: "/attachments/medialib/89683c73-cf2b-44d8-9a06-e48d9d2df209-1759338433227-672669435-Health Accounts System of Dubai 2020.pdf",
          image:
            "/attachments/medialib/becb7d82-df36-464c-b97c-365d255093ef-1759740758630-6940733-Reports_HASD_2020.jpg",
        },
        {
          id: 6,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2019",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2019",
          file: "/attachments/medialib/78ff2a85-a950-4169-a78b-01b0dc929ae7-1759324217043-157746757-Health Accounts System of Dubai 2019.pdf",
          image:
            "/attachments/medialib/7350d081-3f60-4b76-8894-66cc27d77980-1759740749768-498425477-Reports_HASD_2019.jpg",
        },
        {
          id: 7,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2018",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2018",
          file: "/attachments/medialib/a18ec1f4-888d-49d5-a677-a54ef744bed9-1759324203988-520829534-Health Accounts System of Dubai 2018.pdf",
          image:
            "/attachments/medialib/657bf769-7698-4a7f-a41d-b35d63a67200-1759740742347-332371636-Reports_HASD_2018.jpg",
        },
        {
          id: 8,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2016-2017",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2016-2017",
          file: "/attachments/medialib/d1883c15-8280-43b2-ad93-1f690a6dd4df-1759324184927-196820151-Health Accounts System of Dubai 2016-2017.pdf",
          image:
            "/attachments/medialib/2167ceb1-e771-4884-a24e-117d33dac171-1759740733803-131736428-Reports_HASD_2016-2017.jpg",
        },
        {
          id: 9,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2013-2014",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2013-2014",
          file: "/attachments/medialib/f4df114d-8446-41e3-b0d0-8fd12af610a7-1759324160080-549019380-Health Accounts System of Dubai 2013-2014.pdf",
          image:
            "/attachments/medialib/ebbe9302-8bbd-43a8-a56b-202dc18c6267-1759740618498-223976513-Reports_HASD_2013-2014.jpg",
        },
        {
          id: 91,
          type: "reports",
          titleEN: "HASD - Health Accounts System of Dubai 2012",
          titleAR: "حصــد – نظام الحسابات الصحية في دبي 2012",
          file: "/attachments/medialib/843523de-3be5-443b-8e22-2b3df3768dc6-1759324147337-555843608-Health Accounts System of Dubai 2012.pdf",
          image:
            "/attachments/medialib/a81d7a49-71fb-47d9-ac69-98ddff085c7e-1759740605903-640602374-Reports_HASD_2012.jpg",
        },
        {
          id: 10,
          type: "books",
          titleEN:
            "Dubai Challenge: The Experience of Tackling the Covid-19 Pandemic",
          titleAR: "تحدّي دبي: تجربة التصدي لجائحة كوفيد-19",
          file: "https://www.dha.gov.ae/uploads/DHATheChallenge/index.html",
          image:
            "/attachments/medialib/b77934cb-65ec-4d43-a667-b7aec209d711-1759740995136-577472756-Book_Dubai Challenge.jpg",
        },
        {
          id: 11,
          type: "medical-library",
          titleEN: "DHA Medical Library",
          titleAR: "المكتبة الطبية لهيئة الصحة بدبي",
          file: "https://library.dha.gov.ae/",
          image:
            "/attachments/medialib/e13a93f4-49c1-4217-b84e-d692f5a42ad6-1759741250647-855691604-Medical Library.jpg",
        },
        {
          id: 12,
          type: "journals",
          titleEN: "Dubai Medical Journal",
          titleAR: "مجلة دبي الطبية",
          file: "https://kneopen.com/journal/dmj/",
          image:
            "/attachments/medialib/af02bd54-398b-4c26-b008-b7d5851e27f8-1759741210422-477257853-Journals_Dubai Medical.jpg",
        },
        {
          id: 13,
          type: "articles",
          titleEN:
            "Cost-Effectiveness of Kidney Transplantation Versus Hemodialysis in Dubai",
          titleAR: "فعالية تكلفة زراعة الكلى مقارنة بغسيل الكلى في دبي",
          file: "/attachments/medialib/7aa89467-1765-4b65-bdf7-1d6fd1dfc4a8-1759339270164-413705142-Kidney Transplant vs. Hemodialysis in Dubai.pdf",
          image:
            "/attachments/medialib/f6eee3e3-8245-451a-b781-90c172ed69e6-1781256618742-217830624-Articles and Studies_Kidney Transplant vs. Hemodialysis in Dubai.jpg",
        },
        {
          id: 14,
          type: "articles",
          titleEN: "Burden of COPD in Dubai: A health economics perspective",
          titleAR: "عبء مرض الانسداد الرئوي المزمن في دبي",
          file: "/attachments/medialib/1e992d90-da74-4d4e-84db-5dc44d7d3f3b-1759339225723-326403002-Burden of COPD in Dubai A Health economics perspective.pdf",
          image:
            "/attachments/medialib/8dc9614c-f143-4ace-a043-27e9bc1084ad-1781256625597-261461283-Articles and Studies_Burden of COPD.jpg",
        },
        {
          id: 15,
          type: "articles",
          titleEN: "Cost of Breast Cancer Treatment by Comorbidity in Dubai.",
          titleAR: "تكلفة علاج سرطان الثدي حسب الأمراض المصاحبة في دبي",
          file: "/attachments/medialib/3f04fc50-ebc6-4949-8045-efa79bf020c3-1789019703244-310583559-Cost of Breast Cancer_Publication.pdf",
          image:
            "/attachments/medialib/c74e7357-465a-4e76-92c8-e925c3e74845-1789019742959-444597886-Articles and Studies_Cost of Breast Cancer Treatment by Comorbidity in Dubai.png",
        },
      ],
    }),
    [],
  );

  useEffect(() => {
    const handleInputChanged = (e) => {
      const value = e.target?.value || e.detail?.value || "";
      setSearch(value);
    };

    const handleOnChanged = (e) => {
      const value = e.target?.value || e.detail?.value || "";
      setSearch(value);
    };

    const searchElement = searchInputRef.current;
    if (searchElement) {
      searchElement.addEventListener("inputChanged", handleInputChanged);
      searchElement.addEventListener("onChanged", handleOnChanged);

      return () => {
        searchElement.removeEventListener("inputChanged", handleInputChanged);
        searchElement.removeEventListener("onChanged", handleOnChanged);
      };
    }
  }, []);

  const filteredPublications = useMemo(() => {
    let filtered = publicationsData.items;

    if (activeCategory !== "all") {
      filtered = filtered.filter((item) => item.type === activeCategory);
    }

    if (search && search.trim() !== "") {
      const searchLower = search.toLowerCase().trim();
      filtered = filtered.filter((item) => {
        const title = currentLang === "en" ? item.titleEN : item.titleAR;
        return title.toLowerCase().includes(searchLower);
      });
    }

    return filtered;
  }, [search, activeCategory, currentLang, publicationsData.items]);

  const breadcrumbData = useMemo(() => {
    return [
      {
        text: currentLang === "en" ? "Home" : "الرئيسية",
        icon: "home",
        url: "/",
      },
      {
        text: currentLang === "en" ? "Data & Resources" : "البيانات والمصادر",
        icon: "menu_book",
        url: "#",
      },
      {
        text:
          currentLang === "en"
            ? "Publications"
            : "الإصدارات",
        icon: "menu_book",
        url: "#",
      },
    ];
  }, [currentLang]);

  const handleRadioChange = (categoryId) => {
    setActiveCategory(categoryId);
  };

  const handleSearchInput = (e) => {
    const value = e.target?.value || "";
    setSearch(value);
  };

  return (
    <>
      <dda-breadcrumb
        design="text"
        separator="chevron_right"
        custom_class=""
        component_mode=""
        data-breadcrumbs={JSON.stringify(breadcrumbData)}
      ></dda-breadcrumb>

      <div className="mb-4">
        <img
          className="w-full h-[200px] md:h-[300px] object-cover rounded-xl"
          src={
            config?.banner ||
            "/attachments/medialib/7e9976f3-5be5-4450-a275-18dfcfcbf7ff-1759740386932-172562860-Publications and Medical Library.jpg"
          }
          alt="Hero img"
        />
      </div>

      <h2 className="mb-4 Medium text-primary">
        {currentLang === "en" ? config?.titleEn : config?.titleAr}
      </h2>

      <div className="lg:flex gap-6">
        <div className="lg:w-1/5">
          <div className="border rounded-2xl">
            <p className="body Medium p-4">
              {currentLang === "en"
                ? config?.categoriesLabelEn
                : config?.categoriesLabelAr}
            </p>
            <hr />
            <div className="flex flex-col gap-3 p-4">
              {publicationsData.categories.map((category, i) => (
                <dda-radiobutton
                  key={i}
                  title_text={
                    currentLang === "en" ? category.nameEN : category.nameAR
                  }
                  checked={activeCategory === category.id}
                  size="default"
                  variants="normal"
                  supporting=""
                  error_message=""
                  validation_id="validationId"
                  group_name="publicationCategories"
                  input_id={`${category.id}Id`}
                  custom_class=""
                  component_mode=""
                  aria_label="radio-button"
                  validation_type="normal"
                  onclick={() => handleRadioChange(category.id)}
                ></dda-radiobutton>
              ))}
            </div>
          </div>
        </div>
        <div className="lg:w-4/5">
          <div className="flex flex-wrap items-center gap-3 w-full mb-4 lg:mt-0 mt-4">
            <div className="sm:flex-1">
              <dda-search-input
                ref={searchInputRef}
                placeholder={
                  currentLang === "en"
                    ? "Search publications..."
                    : "ابحث في الإصدارات..."
                }
                size="default"
                custom_class="w-full"
                onInput={handleSearchInput}
                show_button="false"
                helper_text=""
                error_message=""
                validation_id=""
                has_error="false"
                component_mode=""
                button_id="button"
                input_id="Search"
                aria_label="search-input"
                button_aria_label="clear-search"
                search_input_name="search-input"
                close_button_name="close-button"
                search_button_name="search-button"
              ></dda-search-input>
            </div>

            <SegmentedTab onChange={setView} />
          </div>
          <div
            className={
              view === "grid"
                ? "grid xl:grid-cols-4 md:grid-cols-2 gap-5"
                : "flex flex-col gap-4"
            }
          >
            {filteredPublications.length > 0 ? (
              filteredPublications.map((publication) => (
                <PublicationCard
                  key={publication.id}
                  title={
                    currentLang === "en"
                      ? publication.titleEN
                      : publication.titleAR
                  }
                  file={publication.file}
                  image={publication.image}
                  view={view}
                  currentLang={currentLang}
                  type={
                    currentLang === "en"
                      ? publicationsData.categories.find(
                          (cat) => cat.id === publication.type,
                        )?.nameEN
                      : publicationsData.categories.find(
                          (cat) => cat.id === publication.type,
                        )?.nameAR
                  }
                />
              ))
            ) : (
              <div className="col-span-full text-center py-8">
                <p className="text-gray-500">
                  {currentLang === "en"
                    ? "No publications found matching your criteria."
                    : "لم يتم العثور على إصدارات تطابق معايير البحث."}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PublicationsAndMedicalLibrary;
